
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import WaterQuantityPreventiveWorkPopup from './WaterQuantityPreventiveWorkPopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useSearchParams } from 'react-router-dom'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { WaterQuantityDeleteAPI, WaterQuantityTableDataAPI, WaterQuantityTableExportDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/WaterQuantitySlice'
import { Loading } from '../../../../../../Helper/Loading'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../../../../../Helper/Context'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import moment from 'moment'
import { WaterQuantityPreventiveWorkExportData } from './WaterQuantityPreventiveWorkPageExportData'

export default function WaterQuantityPreventiveWorkPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WaterQuantityPreventiveWorkPopupShow, setWaterQuantityPreventiveWorkPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [Heading, setHeading] = useState('')
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    // const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).format('YYYY-MM-DD'));
    const [Date, setDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: HWard && HWard ? HWard : '0',
    //     Label: WLable && WLable ? WLable : "Select...",
    // })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: RoleID == '16' ? 0 : HWard && HWard ? HWard : '0',
        Label: RoleID == '16' ? "Select..." : WLable && WLable ? WLable : "Select...",
    })

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const handleEditOnClick = (item) => {
        setWaterQuantityPreventiveWorkPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterQuantityPreventiveWorkPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: RoleID == '16' ? 0 : HWard,
            Label: RoleID == '16' ? 'Select...' : WLable,
        })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }


    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    useEffect(() => {
        const data = {
            M_ProjectID: 0,
            M_WardID: WardName.ID,
            M_TTP_LocationID: JunctionNameDDL.ID,
            // M_Distri_WS_LocationID: JunctionNameDDL.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            ReadingDate: Date,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            Flag: 'Grid',
            handleWaterQuantityExport: handleWaterQuantityExport
        }
        // if (WardName != 0) {
        dispatch(WaterQuantityTableDataAPI({ data }))
        // }
    }, [IsPost, isSearch, Date, IsClear])
    const { tableData, isLoading } = useSelector(state => state.WaterQuantityTableData)

    const handleWaterQuantityExport = () => {
        const data = {
            M_ProjectID: 0,
            M_WardID: WardName.ID,
            M_TTP_LocationID: JunctionNameDDL.ID,
            // M_Distri_WS_LocationID: JunctionNameDDL.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            ReadingDate: Date,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            Flag: 'Report',
        }
        // if (WardName != 0) {
        dispatch(WaterQuantityTableExportDataAPI({ data }))
        // }
    }
    // , [IsPost, isSearch, Date, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.WaterQuantityTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_TTP_WaterQualityID: item.t_TTP_WaterQualityID,
            T_Distri_WS_WaterQuantityID: item.t_Distri_WS_WaterQuantityID,
            T_WS_WaterMainLineQuantityID: item.t_wS_WaterMainLineQuantityID,
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            handleIsPost: handleIsPost,
            RoleID: RoleID
        }

        dispatch(WaterQuantityDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WaterQuantityDeleteData)



    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-8'>
                                <h5 className="mt-2">
                                    {searchName}
                                </h5>
                            </div>
                            <div className='col-4 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <WaterQuantityPreventiveWorkExportData
                                                ExcelData={ExportTableData}
                                                Date={Date}
                                                name='Water Quantity'
                                                RoleID={RoleID}
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-3 col-md-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="Date"
                                                        value={Date}
                                                        onChange={(e) => (setDate(e.target.value))}
                                                    />
                                                </div>

                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>
                                            {
                                                ((DashProjectTypeId == '6' && RoleID != '16') || DashProjectTypeId == '9')?
                                                    <>
                                                        <div className="col-lg-3 col-md-3">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={JunctionNameDDL}
                                                                setDistributionLineLocationDDL={setJunctionNameDDL}
                                                                WardName={WardName}

                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="col-lg-3 col-md-3">
                                                        <JunctionNameDataDDL
                                                            JunctionNameDDL={JunctionNameDDL}
                                                            setJunctionNameDDL={setJunctionNameDDL}
                                                            WardName={WardName}
                                                        />

                                                    </div>
                                            }

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">
                                            {
                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                    <>
                                                        <table id="totalordergenerated"
                                                            cellPadding="0"
                                                            cellSpacing="0"
                                                            border="0"
                                                            className="table table-bordered "

                                                        >

                                                            <thead >
                                                                <tr  >
                                                                    <th rowSpan={2} className='new_grid sr-no-col'>Sr No.</th>
                                                                    {
                                                                        (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                            <th rowSpan={2} className='new_grid'>Location</th>
                                                                            :
                                                                            <th rowSpan={2} className='new_grid'>Junction</th>
                                                                    }
                                                                    <th rowSpan={2} className='new_grid'>Pipe Size</th>
                                                                    <th colspan="3" className='new_grid'>Incoming Flow</th>
                                                                    <th colspan="3" className='new_grid'>Outgoing Flow</th>
                                                                    <th rowSpan={2} className='new_grid action-col'>Action</th>
                                                                </tr>
                                                                <tr>
                                                                    <th className='new_grid'>Yesterday Reading</th>
                                                                    <th className='new_grid'>Today's Reading</th>
                                                                    <th className='new_grid'>Incoming Water in MLD</th>
                                                                    <th className='new_grid'>Yesterday Reading</th>
                                                                    <th className='new_grid'>Today's Reading</th>
                                                                    <th className='new_grid'>Outgoing Water in MLD</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item, i) => (
                                                                        <tr >
                                                                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                                                                            {
                                                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                                    <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                                    :
                                                                                    <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                                            }
                                                                            <td style={{ textAlign: "right" }}>{item.pipelineDetails ? item.pipelineDetails : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.incomingInitialReading ? item.incomingInitialReading : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.incomingFinalReading ? item.incomingFinalReading : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.incomingWaterINMLD ? item.incomingWaterINMLD : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.outgoingInitialReading ? item.outgoingInitialReading : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.outgoingFinalReading ? item.outgoingFinalReading : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.outgoingWaterINMLD ? item.outgoingWaterINMLD : '0'}</td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {
                                                                                    (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                        <>
                                                                                            <span>
                                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                                >
                                                                                                </i>
                                                                                            </span>
                                                                                            <span>
                                                                                                <DeletePopup
                                                                                                    open={DeletePopupShow}
                                                                                                    item={item}
                                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                                />
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        '-'
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )) :
                                                                        <td colSpan={15}>No data found</td>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </>
                                                    :
                                                    <>
                                                        <table id="totalordergenerated"
                                                            cellPadding="0"
                                                            cellSpacing="0"
                                                            border="0"
                                                            className="table table-bordered "

                                                        >

                                                            <thead >
                                                                <tr>
                                                                    <th rowSpan={2} className='new_grid'>Sr No.</th>
                                                                    <th rowSpan={2} className='new_grid'>Reading Date</th>
                                                                    <th rowSpan={2} className='new_grid'>Junction</th>
                                                                    <th rowSpan={2} className='new_grid'>Pipe Size</th>
                                                                    <th colspan="2" className='new_grid'>Water Reading</th>
                                                                    <th rowSpan={2} className='new_grid'>Water in MLD</th>
                                                                    <th rowSpan={2} className='new_grid'>Action</th>
                                                                </tr>
                                                                <tr>
                                                                    <th className='new_grid'>Yesterday Reading</th>
                                                                    <th className='new_grid'>Today's Reading</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item, i) => (
                                                                        <tr >
                                                                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                                                                            <td>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                            <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                                            <td>{item.pipelineDetails ? item.pipelineDetails : '0'}</td>
                                                                            <td>{item.yesterdayReading ? item.yesterdayReading : '0'}</td>
                                                                            <td>{item.todayReading ? item.todayReading : '0'}</td>
                                                                            <td>{item.waterINMLD ? item.waterINMLD : '0'}</td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {
                                                                                    (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                        <>
                                                                                            <span >

                                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                                >
                                                                                                </i>
                                                                                            </span>
                                                                                            <span>
                                                                                                <DeletePopup
                                                                                                    open={DeletePopupShow}
                                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                                    item={item}
                                                                                                />
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        '-'
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )) :
                                                                        <td colSpan={15}>No data found</td>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </>
                                            }

                                        </div>
                                        {/* {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        } */}

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WaterQuantityPreventiveWorkPopupShow ?
                        <WaterQuantityPreventiveWorkPopup
                            open={WaterQuantityPreventiveWorkPopupShow}
                            // popupHeading="Water Quality-Chlorine"                        
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}